<script>

export default {
    props: {
        label: {type: String, required: true},
        filterValues: {type: Array, required: true},
        activeFilterValues: {type: Array, required: true, default: function(){return []}},
        // When set, the toggle is rendered as an icon tool-button (icon + small
        // caption, like Favoriten/History) instead of the text-label dropdown.
        icon: {type: String, default: ''},
    },

    data() {
        return {
            showDropdown: false,
        }
    },

    computed: {
        hasActive() {
            return this.activeFilterValues && this.activeFilterValues.length > 0
        },
    },

    methods: {
        displayValue(val) {
            return val.name || val
        },
        key(val) {
            return val.id || val
        },
        isActive(val) {
            // includes does not work because of query param string types
            for (let v of this.activeFilterValues)
                if (v == this.key(val)) return true
            return false
        }
    }
}
</script>

<template>
    <li class="nav-item dropdown">
        <div v-if="icon" class="btn btn-sm navbar-btn me-1 mb-1 c-tool-btn"
         :class="hasActive ? 'text-primary' : ''" style="cursor:pointer"
         :title="label" @click.prevent="showDropdown=!showDropdown">
            <i :class="icon"></i>
            <span class="c-tool-btn-label">{{ label }}</span>
        </div>
        <div v-else class="btn bg-secondary w-100 btn-sm-lg navbar-btn dropdown-toggle me-1 mb-1"
         @click.prevent="showDropdown=!showDropdown">
            {{ label }}
        </div>
        <div v-if="showDropdown" class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
            <template v-for="val in filterValues">
                <label class="dropdown-item" :key="val">
                <input type="checkbox"
                    @change="$emit('toggle-filter', val)"
                    :checked="isActive(val)"
                />&nbsp; {{displayValue(val)}}
                </label>
            </template>
        </div>
    </li>
</template>

<style scoped>

/* The dropdown is toggled via v-if; make it overlay the navbar instead of
   pushing content and expanding the filter container. */
.nav-item.dropdown {
    position: relative;
}
.dropdown-menu {
    position: absolute;
    display: block;
    top: 100%;
    left: 0;
    z-index: 1056;
    max-height: 60vh;
    overflow-y: auto;
}

/* Icon tool-button variant (icon + small caption), matching Favoriten/History. */
.c-tool-btn {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.2;
}
.c-tool-btn-label {
    font-size: 0.65rem;
    margin-top: 2px;
}

.c-talk-navbar .nav-link, .c-talk-navbar .dropdown-item {
    text-decoration: none
}

@media screen and (min-width: 960px) {
    .btn-block {
        display: inline-block;
        width: auto;
    }

    .btn-sm-lg {
        padding: 0.25rem 0.5rem;
        font-size: 0.8rem;
        line-height: 1.5;
        border-radius: 0rem;
    }
}
</style>